var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "mx-auto",
      class: { "pa-4": _vm.padding, cardClass: _vm.cardClass },
      staticStyle: {
        "box-shadow":
          "0 8px 32px rgb(47 60 74 / 1%), 0 8px 16px rgb(47 60 74 / 2%)",
      },
      attrs: {
        color:
          _vm.$vuetify.theme.dark && _vm.color == "white" ? "dark" : _vm.color,
        dark: _vm.$vuetify.theme.dark,
        "max-width": "100%",
      },
    },
    [
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            height: "100%",
            width: "100%",
            type: "card",
            loading: _vm.getThemeMode.isLoading,
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }